export default __webpack_public_path__ + "static/sirisha-bandla-0bcd9a6e10d52e96ac299ac2f47d903d.jpg";